import React, { useState, useEffect } from 'react';
import ApiService from '../../functions/apiService';
import { Paper, Grid, Typography, TextField, Autocomplete, Avatar, CircularProgress, MenuItem } from '@mui/material';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import InputAdornment from "@mui/material/InputAdornment";
import './checklist.css'
import ButtonDatePicker from '../../components/DatePickers/ButtonDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Multiselect from 'multiselect-react-dropdown';

const EditChecklist = () => {
  let { id } = useParams();
  let navigate = useNavigate();
  const [employees, setEmployees] = useState([])
  const [loading, setLoading] = useState(true);
  const [checklistDesc, setChecklistDesc] = useState('');
  const [checklistItem, setChecklistItem] = useState('');
  const [detailsArr, setDetailsArr] = useState([]);
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [locationDrop, setLocationDrop] = useState([]);
  const [duration, setDuration] = useState("");
  const [date, setDate] = useState(new Date());
  const [day, setDay] = useState("")
  const [assignedTo, setAssignedTo] = useState(null);
  const [position, setPosition] = useState(null);
  const [positionDrop, setPositionDrop] = useState([]);
  const [time, setTime] = useState(null);
  const [itemDrop, setItemDrop] = useState([]);
  const [activeTab, setActiveTab] = useState('checklist')
  const [ticketNotifyTo, setTicketNotifyTo] = useState("");
  const [ticketAssignTo, setTicketAssignTo] = useState("");
	const [checklistUpdateTo, setChecklistUpdateTo] = useState("");

  const loadEmployees = () => {
    ApiService.get('/employee-list-inventory')
      .then(({ data }) => {
        var tempArr = []
        data?.data.map((emp) => {
          // var obj = emp
          var obj = {
            label: `${emp.employee_assignment.EA_Rank} ${emp.fullName}`,
            value: emp.Emp_Code
          }
          // obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
          // obj.value = emp.Emp_Code
          tempArr.push(obj)
        })
        setEmployees(tempArr)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const getPositionDropown = () => {
    ApiService.get('/positions-list')
      .then(({ data }) => {
        var certArr = data?.data?.map((cer) => { return { label: cer.SO_Desc, value: cer.SO_Value } })
        setPositionDrop(certArr)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const getLocation = () => {
    ApiService.get('/checklist/location')
      .then(({ data }) => {
        var posArr = data?.data?.map((pos) => { return { label: pos.location_description, value: pos.id } })
        setLocationDrop(posArr)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  const updateChecklist = () => {
    var addedDetails = [...detailsArr]
    if (checklistItem != '') {
      let obj = {
        desc: checklistDesc,
        item: checklistItem.value,
        label: checklistItem.label
      }
      addedDetails.push(obj)
    }
    // var tempDetails = addedDetails.map((arr) => { return { description: arr?.desc?.length > 0 ? arr.desc : null, item_id: arr.item || arr.item_location_id } })
    var tempDay = duration == 'monthly' ? moment(date).format('YYYY-MM-DD') : day
    const body = {
      "checklist_id": id,
      "parent_location_id": location?.value,
      "title": title,
      "duration": duration,
      "day": tempDay,
      "assignedTo": assignedTo?.value,
      "position": position?.value,
      "time": moment(time).format('HH:mm:ss'),
      "ticket_assigned_to": ticketAssignTo?.value,
      "notify_employees": ticketNotifyTo.map((a)=>{return a?.value}),
			"notify_checklist_update_to": checklistUpdateTo?.value
    }
    setLoading(true);
    ApiService.post('/checklist/updateDetail', body)
      .then((data) => {
        setLoading(false);
        toast.success(data.message)
        navigate("/firehouse/checklist");
      })
      .catch((error) => {
        setLoading(false)
        if (error.status == 422) {
          Object.keys(error.data.errors).map((err) => (
            toast.error(error.data.errors[err][0])
          ))
        }
        else {
          toast.error(error.data.message)
        }
      })
  }

  const getChecklistData = () => {
    if (id) {
      setLoading(true);
      ApiService.get('/checklist/edit_details/' + id)
        .then(async ({ data }) => {
          setTitle(data?.data?.title)
          var tempLoc = locationDrop.find(a => a.value == data?.data?.location_id)
          setLocation(tempLoc)
          // await getItem(tempLoc)
          setDuration(data?.data?.duration)
          setDay(data?.data?.day)
          setDate(new Date(data?.data?.day))
          setTime(new Date(`${moment().format('YYYY-MM-DD')} ${data?.data?.time}`))
          var tempAssign = employees.find(a => a.value == data?.data?.checklist_assign?.emp_id)
          setAssignedTo(tempAssign)
          var tempAssignTicket = employees.find(a => a.value == data?.data?.ticket_assigned_to)
          setTicketAssignTo(tempAssignTicket)
					let notifyEmpCodes = data?.data?.notify?.map(n => n.notify_emp_code)
          var tempNotifyTicket = employees.filter(a => notifyEmpCodes.includes(a.value))
          setTicketNotifyTo(tempNotifyTicket)
					var tempUpdateChecklist = employees.find(a => a.value == data?.data?.notify_checklist_update_to)
          setChecklistUpdateTo(tempUpdateChecklist)
          // var tempDetArr = data?.data?.checklist_item?.map((item) => {
          //   return ({
          //     desc: item?.description,
          //     item: item?.item_location?.item_id,
          //     label: itemDrop.find(a => a.value == item?.item_location?.item_id)?.label
          //   })
          // })
          // setDetailsArr(tempDetArr)
          // if (itemDrop.length > 0) {
          setLoading(false);
          // }
          var tempPos = positionDrop.find(a => a.value == data?.data?.checklist_assign?.position)
          setPosition(tempPos)
        })
        .catch((e) => {
          setLoading(false);
        })
    }
  }

  const durationOptions = [
    { label: "Daily", value: "daily" },
    { label: "Every Other Day", value: "everyotherday" },
    { label: "Weekly", value: "weekly" },
    { label: "Bi-weekly", value: "biweekly" },
    { label: "Monthly", value: "monthly" }
  ]

  const dayOptions = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" }
  ]

  useEffect(() => {
    if (employees.length == 0) {
      loadEmployees()
    }
  }, [employees])

  useEffect(() => {
    if (locationDrop.length == 0) {
      getLocation()
    }
  }, [locationDrop])

  useEffect(() => {
    if (positionDrop.length == 0) {
      getPositionDropown()
    }
  }, [positionDrop])

  useEffect(() => {
    if (locationDrop.length > 0 && employees.length > 0) {
      getChecklistData()
    }
  }, [locationDrop, employees])

  // useEffect(() => {
  //   if (itemDrop.length > 0 && employees.length > 0) {
  //     getChecklistData()
  //   }
  // }, [itemDrop])

  return (
    <>
      {loading ? (
        <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
          <CircularProgress />
        </Paper>
      )
        : (
          <Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Typography variant="h5">
                  <Link to="/firehouse/checklist" style={{ color: "black" }}>
                    <ArrowBackIosIcon />
                  </Link>
                  Edit Checklist Definition</Typography>
              </Grid>

              <Grid item xs={12} md={7} sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: '195px' }} className={activeTab == 'checklist' ? 'tab-active' : 'tab-white'}
                  onClick={() => {
                    setActiveTab('checklist')
                    navigate(`/firehouse/edit-checklist/${id}`)
                  }}
                >
                  Update Basic Definition
                </div>
                <div style={{ width: '195px' }} className={activeTab == 'checklist-items' ? 'tab-active mx-2' : 'tab-white mx-2'}
                  onClick={() => {
                    setActiveTab('checklist-items')
                    navigate(`/firehouse/edit-checklist-items/${id}`)
                  }}
                >
                  Update Location & Items
                </div>
              </Grid>
            </Grid>

            <Grid container spacing={2} className='mt-3'>

              {/* Parent Location */}
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Parent Location</label>
                <Autocomplete
                  options={locationDrop}
                  getOptionLabel={(option) => option.label}
                  onChange={(event, newValue) => setLocation(newValue?.value || "")}
                  value={location}
									disabled={true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Location"
                      variant="outlined"
                      fullWidth
                      size="small"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "48px",
                          fontSize: "14px"
                        }
                      }}
                    />
                  )}
                />
              </Grid>

              {/* Title */}
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Title</label>
                <TextField
                  fullWidth
                  variant="outlined"
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                  defaultValue={title}
                  placeholder={"Enter Title"}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "48px",
                      fontSize: "14px"
                    }
                  }}
                />
              </Grid>

              {/* Postion */}
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Assign by Position</label>
                <Autocomplete
                  options={positionDrop}
                  disabled={assignedTo != null ? true : false}
                  onChange={(event, newValue) => setPosition(newValue)}
                  value={position}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "48px",
                      fontSize: "14px"
                    }
                  }}
                  renderInput={(params) => <TextField {...params} placeholder="Select Postions" />}
                />
              </Grid>

              {/* Assigned to */}
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Assign by Employee</label>
                <Autocomplete
                  options={employees}
                  disabled={position != null ? true : false}
                  value={assignedTo}
                  onChange={(event, newValue) => { setAssignedTo(newValue) }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "48px",
                      fontSize: "14px"
                    }
                  }}
                  renderInput={(params) => <TextField {...params} placeholder="Select Employee" />}
                />
              </Grid>

              {/* Ticket Assign to */}
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Assign Ticket to</label>
                <Autocomplete
                  options={employees}
                  value={ticketAssignTo}
                  onChange={(event, newValue) => { setTicketAssignTo(newValue) }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "48px",
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center"
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Employee"
                    />
                  )}
                />
              </Grid>

							{/* Ticket Notify to */}
							<Grid item xs={12} sm={6} md={4}>
								<label className='my-2'>Notify Ticket to</label>

								<Multiselect
									displayValue="label"
									options={employees}
									showCheckbox
									showArrow
									customCloseIcon={<><img src='/images/cross.png' /></>}
									placeholder='Select Employees'
									selectedValues={ticketNotifyTo}
									onSelect={(e) => setTicketNotifyTo(e)}
									onRemove={(e) => setTicketNotifyTo(e)}
								/>
							</Grid>

              {/* Duration */}
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Duration</label>
                <Autocomplete
                  options={durationOptions}
                  getOptionLabel={(option) => option.label}
                  value={duration ? durationOptions.find(opt => opt.value === duration) || null : null}
                  onChange={(_, newValue) => setDuration(newValue ? newValue.value : "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      placeholder="Select Duration"
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "48px",
                          fontSize: "14px"
                        }
                      }}
                    />
                  )}
                />
              </Grid>

              {/* Calender */}
              {(duration == 'monthly' || duration == 'everyotherday') &&
                <Grid item xs={12} sm={6} md={4} className='d-grid'>
                  <label className='my-2'>Date</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <ButtonDatePicker
                      className='w-100'
                      label={moment(date).format('YYYY-MM-DD')}
                      value={date}
                      onChange={(e) => setDate(e)}
                      minDate={new Date()}
                    />
                  </LocalizationProvider>
                </Grid>}

              {/*Select Days drop down */}
              {(duration == 'weekly' || duration == 'biweekly') &&
                <Grid item xs={12} sm={6} md={4}>
                  <label className='my-2'>Select Day</label>
                  <Autocomplete
                    options={dayOptions}
                    getOptionLabel={(option) => option.label}
                    value={day ? dayOptions.find(opt => opt.value === day) || null : null}
                    onChange={(_, newValue) => setDay(newValue ? newValue.value : "")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        placeholder="Select Day"
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "48px",
                            fontSize: "14px"
                          }
                        }}
                      />
                    )}
                  />
                </Grid>}

              {/* Time Dropdown */}
              <Grid item xs={12} sm={6} md={4}>
                <label className='my-2'>Time</label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <TimePicker
                    // timeSteps={{ minutes: 1 }}
                    value={time}
                    onChange={(newValue) => setTime(newValue)}
                    className='mt-0'
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: '48px',
                        fontSize: '14px'
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid>

							{/* Notify Checklist Update to */}
							<Grid item xs={12} sm={6} md={4}>
								<label className='my-2'>Notify Checklist Update to*</label>
								<Autocomplete
									options={employees}
									value={checklistUpdateTo}
									onChange={(event, newValue) => { setChecklistUpdateTo(newValue) }}
									sx={{
										"& .MuiInputBase-root": {
											height: "48px",
											fontSize: "14px",
											display: "flex",
											alignItems: "center"
										}
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											placeholder="Select Employee"
										/>
									)}
								/>
							</Grid>

              {/* Buttons */}
              <Grid item container md={12} gap={4} style={{ marginTop: '8px' }}>

                {/* Add Button */}
                <Grid item xs={6} md={1} onClick={() => updateChecklist()}>
                  <ButtonTheme type='submit' variant="filled" color='primary' style={{ width: "140px", height: "40px" }}>
                    Update
                  </ButtonTheme>
                </Grid>

                {/* Cancel Button */}
                <Grid item xs={6} md={1}>
                  <Link to="/firehouse/checklist">
                    <ButtonTheme
                      type='submit'
                      variant="filled"
                      color='#D0D5DD'
                      style={{ color: "#FFFFFF", width: "140px", height: "40px", marginLeft: "50px" }}>
                      Cancel
                    </ButtonTheme>
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Paper >
        )
      }
    </>
  )
}
export default EditChecklist;

{/* Checklist Details Heading */ }
// <Grid item xs={12} sm={12} md={12} style={{ marginTop: '20px' }}>
//     <div className='d-flex justify-content-between '>
//         <Typography variant="h6">Checklist Detail</Typography>
//         <div className='d-flex justify-content-between add-gap'>
//             <button className='add-btn'
//                 onClick={() => setShowDescription(true)}>
//                 <Avatar src="/images/Plus-Blue.png" style={{ width: 25, height: 25 }} />
//             </button>
//             <Typography variant="h8">Add new</Typography>
//         </div>
//     </div>
// </Grid>

// {showDescription &&
//     <>
{/* Add Decription */ }
// <Grid item xs={12} sm={6} md={6}>
//     <label className='my-2'>Add Description</label>
//     <TextField
//         fullWidth
//         variant="outlined"
//         size="small"
//         placeholder={"Add"}
//         value={checklistDesc}
//         onChange={(e) => setChecklistDesc(e.target.value)}
//         sx={{
//             "& .MuiInputBase-root": {
//                 height: "48px",
//                 fontSize: "14px"
//             }
//         }}
//     />
// </Grid>

{/* Item dropdown */ }
// <Grid item xs={12} sm={6} md={2.5}>
//     <label className='my-2'>Item</label>
//     <Autocomplete
//         options={itemDrop}
//         onChange={(event, newValue) => setChecklistItem(newValue)}
//         value={checklistItem}
//         sx={{
//             "& .MuiInputBase-root": {
//                 height: "48px",
//                 fontSize: "14px"
//             }
//         }}
//         renderInput={(params) => <TextField {...params} placeholder="Please Select" />}
//     />
// </Grid>

{/* Location dropdown */ }
// <Grid item xs={12} sm={6} md={2.5}>
//     <label className='my-2'>Location</label>
//     <Autocomplete
//         options={itemDrop}
//         onChange={(event, newValue) => setChecklistItem(newValue)}
//         value={checklistItem}
//         sx={{
//             "& .MuiInputBase-root": {
//                 height: "48px",
//                 fontSize: "14px"
//             }
//         }}
//         renderInput={(params) => <TextField {...params} placeholder="Please Select" />}
//     />
// </Grid>

{/* Plus Button */ }
//     <Grid item xs={12} sm={6} md={1} className='plus-btn'>
//         <button className='add-btn' onClick={addElement}>
//             <Avatar src="/images/Plus-Blue.png" />
//         </button>
//     </Grid>
// </>}

{/* Description Box */ }
// {detailsArr && detailsArr.length > 0 && detailsArr.map((a) => (
//     <Grid item xs={12} sm={6} md={6}>
//         <div>
//             <Grid item>
//                 <TextField
//                     fullWidth
//                     variant="outlined"
//                     size="normal"
//                     height="75px"
//                     disabled
//                     multiline
//                     value={a.desc || 'NO DESCRIPTION'}
//                     InputProps={{
//                         sx: {
//                             '& fieldset': { borderColor: '#CCCCCC' },
//                             backgroundColor: '#F5F5F566',
//                             '& .MuiInputBase-input.Mui-disabled': {
//                                 color: 'black',
//                                 WebkitTextFillColor: a.desc == null || a.desc == '' ? '#D0D5DD !important' : 'black !important',
//                                 fontFamily: "Karla",
//                                 fontWeight: "400"
//                             },
//                         },


//                         startAdornment: (
//                             <InputAdornment position="start">
//                                 <img src='/images/Building.png' style={{ width: 30, height: 30 }} />
//                             </InputAdornment>
//                         ),
//                         endAdornment: (
//                             <InputAdornment position="end">
//                                 <Grid container direction="column" alignItems="flex-end">

//                                     <Grid item md={12}>
//                                         <button className='add-btn' onClick={() => {
//                                             setShowDescription(true)
//                                             editElement(a)
//                                         }}>
//                                             <img src='/images/edit.png' style={{ width: 15, height: 15 }} />
//                                         </button>
//                                         <button className='add-btn' onClick={() => deleteElement(a)}>
//                                             <img src='/images/cross 1.png' style={{ width: 16, height: 16, marginLeft: 8 }} />
//                                         </button>
//                                     </Grid>

//                                     <Grid item md={12}>
//                                         <Typography variant="body2" className='mt-1'>
//                                             <span className='font-fam-2'>Item: </span> <span className='item-style'>{a.label}</span>
//                                         </Typography>
//                                     </Grid>

//                                 </Grid>
//                             </InputAdornment>
//                         )
//                     }}
//                 />
//             </Grid>
//         </div>
//     </Grid>
// ))}


// const getItem = (loc = '') => {
//   if (loc?.value || location?.value) {
//     const body = {
//       "location_id": loc?.value || location?.value
//     }
//     ApiService.post('/checklist/location_item', body)
//       .then((data) => {
//         var load = data?.data?.my_items.map((ldd) => { return { label: ldd.item_description, value: ldd.id } })
//         setItemDrop(load || [])
//       })
//       .catch((e) => {
//         console.log(e)
//       })
//   }
// }

// const addElement = () => {
//   if (checklistItem == '') {
//     toast.error('Please add item')
//   }
//   else {
//     let tempArr = [...detailsArr]
//     let obj = {
//       desc: checklistDesc,
//       item: checklistItem.value,
//       label: checklistItem.label
//     }
//     tempArr.push(obj)
//     setDetailsArr(tempArr)
//     setChecklistDesc('')
//     setChecklistItem('')
//   }
// }

// const deleteElement = (a) => {
//   let tempArr = [...detailsArr]
//   const index = tempArr.indexOf(a)
//   tempArr.splice(index, 1)
//   setDetailsArr(tempArr)
// }

// const editElement = (a) => {
//   setChecklistDesc(a.desc)
//   setChecklistItem({ label: a.label, value: a.item })
//   deleteElement(a)
// }

// useEffect(() => {
//   getItem()
// }, [location])
